import loggingService from '../services/util/loggingService'
import dateService from '../services/util/dateService'

var serviceName = 'letterTemplateService'
var path = '/LetterTemplate/'
var isDebug = false

const DataFieldReferenceList = [
    {
        dataField: '%CurrentDate%',
        dataFieldDescription: 'Current Date'
    },
    {
        dataField: '%PROAgencyName%',
        dataFieldDescription: 'Project Agency Name'
    },
    {
        dataField: '%PROAgencyAddress%',
        dataFieldDescription: 'Project Agency Full Address'
    },
    {
        dataField: '%PROConsultantName%',
        dataFieldDescription: 'Project Consultant Name'
    },
    {
        dataField: '%PROConsultantAddress%',
        dataFieldDescription: 'Project Consultant Full Address'
    },
    {
        dataField: '%PROClientName%',
        dataFieldDescription: 'Project Client Name'
    },
    {
        dataField: '%PROClientAddress%',
        dataFieldDescription: 'Project Client Full Address'
    },
    {
        dataField: '%PROProjectName%',
        dataFieldDescription: 'Project Name'
    },
    {
        dataField: '%PROProjectDbNumber%',
        dataFieldDescription: 'Project DB Number'
    },
    {
        dataField: '%FWRConsultantName%',
        dataFieldDescription: 'Fieldwork Consultant Name'
    },
    {
        dataField: '%FWRConsultantAddress%',
        dataFieldDescription: 'Fieldwork Consultant Full Address'
    },
    {
        dataField: '%FWRFieldworkDbNumber%',
        dataFieldDescription: 'Fieldwork Request DB Number'
    },
    {
        dataField: '%INVInvestigationName%',
        dataFieldDescription: 'Investigation Report Title'
    },
    {
        dataField: '%INVInvestigationDbNumber%',
        dataFieldDescription: 'Investigation DB Number'
    },
    {
        dataField: '%INVSiteListTable%',
        dataFieldDescription: 'List all sites and their eligibilities under the investigation'
    },
    {
        dataField: '%INVSiteEligibleList%',
        dataFieldDescription: 'List all Eligible sites under the investigation'
    },
    {
        dataField: '%INVSiteEligibleNoEffectList%',
        dataFieldDescription: 'List Eligible/No Effect sites under the investigation'
    },
    {
        dataField: '%INVSiteEligibleNoAdverseList%',
        dataFieldDescription: 'List Eligible/No Adverse Effect sites under the investigation'
    },
    {
        dataField: '%INVSiteEligibleAdverseList%',
        dataFieldDescription: 'List Eligible/Adverse Effect sites under the investigation'
    },
    {
        dataField: '%INVSiteNotEligibleList%',
        dataFieldDescription: 'List all Not Eligible sites under the investigation'
    },
    {
        dataField: '%INVSiteUnevaluatedList%',
        dataFieldDescription: 'List all Unevaluated sites under the investigation'
    },
    {
        dataField: '%INVSiteListTableSmithNoOnly%',
        dataFieldDescription: 'List only the Smithsonian number for all sites and their eligibilities under the investigation'
    },
    {
        dataField: '%INVSiteEligibleListSmithNoOnly%',
        dataFieldDescription: 'List only the Smithsonian number for all Eligible sites under the investigation'
    },
    {
        dataField: '%INVSiteEligibleNoEffectListSmithNoOnly%',
        dataFieldDescription: 'List only the Smithsonian number for Eligible/No Effect sites under the investigation'
    },
    {
        dataField: '%INVSiteEligibleNoAdverseListSmithNoOnly%',
        dataFieldDescription: 'List only the Smithsonian number for Eligible/No Adverse Effect sites under the investigation'
    },
    {
        dataField: '%INVSiteEligibleAdverseListSmithNoOnly%',
        dataFieldDescription: 'List only the Smithsonian number for Eligible/Adverse Effect sites under the investigation'
    },
    {
        dataField: '%INVSiteNotEligibleListSmithNoOnly%',
        dataFieldDescription: 'List only the Smithsonian number for all Not Eligible sites under the investigation'
    },
    {
        dataField: '%INVSiteUnevaluatedListSmithNoOnly%',
        dataFieldDescription: 'List only the Smithsonian number for all Unevaluated sites under the investigation'
    },
    {
        dataField: '%INVShpoAssignedUser%',
        dataFieldDescription: 'Shpo User name assigned to the investigation'
    },
    {
        dataField: '%CRRSmithsonianNumber%',
        dataFieldDescription: 'Site Smithsonian Number'
    },
    {
        dataField: '%CRRSiteName%',
        dataFieldDescription: 'Site Name'
    },
    {
        dataField: '%CRRCurrentEligibility%',
        dataFieldDescription: 'Site Current Eligibility'
    },
    {
        dataField: '%CRRCurrentEffect%',
        dataFieldDescription: 'Site Current Effect'
    },
    {
        dataField: '%ISOIsolateNumber%',
        dataFieldDescription: 'Isolate Number'
    },
    {
        dataField: '%BUSSurveryName%',
        dataFieldDescription: 'Building Survey Name'
    },
    {
        dataField: '%UNDUndertakingName%',
        dataFieldDescription: 'Undertaking Name'
    },
    {
        dataField: '%UNDUndertakingDbNumber%',
        dataFieldDescription: 'Undertaking DB Number'
    },
    {
        dataField: '%USRPhone%',
        dataFieldDescription: 'User\'s Phone Number'
    },
    {
        dataField: '%USRUsername%',
        dataFieldDescription: 'User\'s Username/Email'
    },
    {
        dataField: '%USRSignature%',
        dataFieldDescription: 'User\'s Signature'
    }
]

function put (http, dto) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path, dto)
}

function get (http, id) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'Get?id=' + id)
}

function search (http, searchDto) {
    loggingService.log(isDebug, serviceName, 'search')

    return http.post(path + 'Search', searchDto).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
            })
        }
        return response
    })
}

function listLetterTemplateType (http) {
    loggingService.log(isDebug, serviceName, 'listLetterTemplateType')

    return http.get(path + 'ListLetterTemplateType').then(response => {
        return response
    })
}

function remove (http, id) {
    loggingService.log(isDebug, serviceName, 'remove')

    return http.post(path + 'Remove?id=' + id).then(response => {
        return response
    })
}

function letterTemplateDataFieldMerge (http, generateLetterPdfDto) {
    loggingService.log(isDebug, serviceName, 'letterTemplateDataFieldMerge')
    return http.post(path + 'LetterTemplateDataFieldMerge', generateLetterPdfDto).then(response => {
        return response
    })
}

export default {
    put: put,
    get: get,
    search: search,
    listLetterTemplateType: listLetterTemplateType,
    remove: remove,
    letterTemplateDataFieldMerge: letterTemplateDataFieldMerge,
    DataFieldReferenceList: DataFieldReferenceList

}



// WEBPACK FOOTER //
// ./src/services/letterTemplateService.js